import axios from 'axios';

import { API_URL, API_KEY } from '../config';

export const maskSensitiveData = (s: string, start: number, end: number) => {
    if (!s) return '';


    //make sure the string is long enough - if it isn't, then it isn't a proper Bearer token, so just return it all, to help debugging
    if (s.length < start + end) {
        return s;
    }
    return s && (s.slice(0, start) + "*".repeat(s.length - (start + end)) + s.slice(s.length - end, s.length));
}

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "x-api-key":API_KEY, "content-type": "application/json" }
});

export default axiosInstance;
